/**
 * Shared display formatters — reusable across all pages.
 */

/** Format an epoch timestamp (seconds) for display. */
export const formatTimestamp = (epoch: number | null | undefined): string => {
  if (epoch == null) return '—';
  const ms = epoch * 1000;
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toISOString().replace('T', ' ').slice(0, 19) + ' UTC';
};

/** Format an ISO timestamp string for display. */
export const formatIsoTimestamp = (iso: string | null | undefined): string => {
  if (iso == null) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString();
};

/** Format latency in milliseconds to human-readable. */
export const formatLatency = (ms: number | null | undefined): string => {
  if (ms == null) return '—';
  if (ms === 0) return '0ms';
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${(ms / 60000).toFixed(1)}min`;
};
